import { ApolloError } from '@apollo/client';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomErrorCodes } from '../../hooks/useMutationErrorHandler';

type Props = {
  error?: ApolloError;
};

const getUserFriendlyMessage = (error?: ApolloError): string | null => {
  if (!error) return null;
  const friendly = error.graphQLErrors.find(
    (e) => e.extensions?.code === CustomErrorCodes.USER_FRIENDLY_BACKEND_ERROR,
  );
  return friendly?.message ?? null;
};

// todo: move to ErrorHandling folder in next PR
const ServerError: React.FC<Props> = ({ error }) => {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <h1 className="display-4 mb-3">{t('errors.500.title')}</h1>
      <p className="text-muted mb-4">
        {getUserFriendlyMessage(error) ?? t('errors.500.description')}
      </p>
    </div>
  );
};

export default ServerError;
